module.exports = __webpack_public_path__ + "img/banner_01.394c70af.jpg";